import { reqUserRegister } from '@/api'

// const tokeTop = 'Bearer ';
const tokeTop = '';
const state = {
    Authorization: localStorage.getItem('Authorization'),
    userInfo: {}
};
const mutations = {
    USERREGISTER(state, Authorization) {
        state.Authorization = Authorization;
    },
    GETUSERINFO(state, userInfo) {
        state.userInfo = userInfo;
    }
};
const actions = {
    // 用户注册
    async userRegister({ commit }, user) {
        let result = await reqUserRegister(user);
        console.log('用户注册-->', result);
        if (result.code == 200) {
            localStorage.setItem('Authorization', tokeTop + result.data.token);
            commit('USERREGISTER', result.data.token);
            return 'ok';
        } else {
            return Promise.reject(new Error(result.msg));
        }
    },
};
const getters = {};

export default {
    state,
    mutations,
    actions,
    getters
}